<div
    class="p-[16px] flex flex-col gap-[16px] bg-p-content-hover-background border-solid border-[1px] border-p-content-border-color rounded-lg font-inter text-color">
    <div class="flex flex-col gap-[8px]">
        <div class="text-xs font-semibold">
            @if (activeSessionState == 'none') {
                Start session now?
            } @else if (activeSessionState == 'searching') {
                Searching for a partner...
            } @else {
                You have an ongoing session.
            }
        </div>
        <div class="text-xs font-medium">
            @if (activeSessionState == 'none') {
                We'll match you with the first available partner. You can start your session right
                away.
            } @else if (activeSessionState == 'searching') {
                Join your session to get matched.
            } @else {
                Happy focusing!
            }
        </div>
    </div>

    @if (activeSessionState === 'none') {
        <p-button
            [buttonProps]="{ autofocus: false }"
            #startSessionButton
            severity="primary"
            size="large"
            styleClass="w-full"
            [disabled]="bookingSession"
            (click)="onClickStartSessionButton()"
            class="w-full"
            [class.bg-grey]="bookingSession">
            @if (!bookingSession) {
                {{ buttonText() }}
            } @else {
                Starting...
                <div
                    class="spin ml-[10px] w-[15px] h-[15px] border-solid border-[2px] border-white border-t-[4px] border-t-grey rounded-full"></div>
            }
        </p-button>
    }
</div>
